export const isBase64 = (str: string) => {
  if (!str) {
    return false;
  }
  const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  return base64regex.test(str);
};

//export const base64Decode = (str: string): string =>
//str ? Buffer.from(str, 'base64').toString('binary') : str;
//export const base64Encode = (str: string): string =>
//str ? Buffer.from(str, 'binary').toString('base64') : str;

export const base64Decode = (str: string): string => {
  const decodedBytes = Uint8Array.from(atob(str), (c) => c.charCodeAt(0)); // Decode Base64 to bytes
  const decoder = new TextDecoder();
  const decodedString = decoder.decode(decodedBytes); // Convert bytes back to UTF-8 string
  return decodedString;
};

export const base64Encode = (str: string): string => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str); // Convert to UTF-8 bytes
  const base64Encoded = btoa(String.fromCharCode(...data)); // Base64 encode the bytes
  return base64Encoded;
};
